import { useApolloClient } from "@apollo/client";
import { useCallback, useEffect } from "react";
import { useRecoilState } from "recoil";
import {
  GetActiveLandingPage,
  GetLandingPageAdmin,
  getAllOpportunityForAdmin,
  getLatestVersionAdmin,
  getMasterClinic,
  getMasterDivision,
  getMasterKota,
  getMasterLokasiInterview,
  getMasterStatusAdmin,
} from "../../GQL/queries";
import {
  getActiveLandingPage,
  getDivision,
  getLandingPageAdmin,
  getMasterClinicAtoms,
  getMasterKotaAtoms,
  getMasterLokasiInterviewAtom,
  getMasterOpportunityAdmin,
  getStatusAdmin,
  getVersionAdmin,
} from "../atoms/MasterDataAtoms";

export const useGetStatusAdmin = () => {
  const [listStatusAdmin, setListStatusAdmin] = useRecoilState(getStatusAdmin);
  const client = useApolloClient();

  const fetchStatusAdmin = useCallback(async () => {
    const statusAdmin = await getMasterStatusAdmin(client);
    setListStatusAdmin(statusAdmin);
  }, [client, setListStatusAdmin]);

  useEffect(() => {
    if (!listStatusAdmin.length) {
      fetchStatusAdmin();
    }
  }, [fetchStatusAdmin, listStatusAdmin.length]);

  return [listStatusAdmin, fetchStatusAdmin];
};

export const useGetVersionAdmin = () => {
  const [listadminVersion, setListAdminVersion] =
    useRecoilState(getVersionAdmin);
  const client = useApolloClient();

  const fetchAdminVersion = useCallback(async () => {
    const adminVersion = await getLatestVersionAdmin(client);
    setListAdminVersion(adminVersion);
  }, [client, setListAdminVersion]);

  useEffect(() => {
    if (!listadminVersion.length) {
      fetchAdminVersion();
    }
  }, [fetchAdminVersion, listadminVersion.length]);

  return [listadminVersion, fetchAdminVersion];
};

export const useGetMasterDivision = () => {
  const [listDivision, setListDivision] = useRecoilState(getDivision);
  const client = useApolloClient();

  const fetchMasterDivision = useCallback(async () => {
    const MasterDivision = await getMasterDivision(client);
    setListDivision(MasterDivision);
  }, [client, setListDivision]);

  useEffect(() => {
    if (!listDivision.length) {
      fetchMasterDivision();
    }
  }, [fetchMasterDivision, listDivision.length]);

  return [listDivision, fetchMasterDivision];
};

export const useGetMasterKota = () => {
  const [listMasterKota, setListMasterKota] =
    useRecoilState(getMasterKotaAtoms);
  const client = useApolloClient();

  const fetchMasterKota = useCallback(async () => {
    const masterKota = await getMasterKota(client);
    setListMasterKota(masterKota);
  }, [client, setListMasterKota]);

  useEffect(() => {
    if (!listMasterKota.length) {
      fetchMasterKota();
    }
  }, [fetchMasterKota, listMasterKota.length]);
  return [listMasterKota, fetchMasterKota];
};

export const useGetMasterLokasiInterview = () => {
  const [listMasterLokasiInterview, setListMasterLokasiInterview] =
    useRecoilState(getMasterLokasiInterviewAtom);
  const client = useApolloClient();

  const fetchMasterLokasiInterview = useCallback(async () => {
    const masterLokasiInterview = await getMasterLokasiInterview(client);
    setListMasterLokasiInterview(masterLokasiInterview);
  }, [client, setListMasterLokasiInterview]);

  useEffect(() => {
    if (!listMasterLokasiInterview.length) {
      fetchMasterLokasiInterview();
    }
  }, [fetchMasterLokasiInterview, listMasterLokasiInterview.length]);

  return [listMasterLokasiInterview, fetchMasterLokasiInterview];
};

export const useGetMasterClinic = () => {
  const [listMasterClinic, setListMasterClinic] =
    useRecoilState(getMasterClinicAtoms);
  const client = useApolloClient();

  const fetchMasterClinic = useCallback(async () => {
    const masterClinic = await getMasterClinic(client);
    setListMasterClinic(masterClinic);
  }, [client, setListMasterClinic]);
  useEffect(() => {
    if (!listMasterClinic.length) {
      fetchMasterClinic();
    }
  }, [fetchMasterClinic, listMasterClinic.length]);

  return [listMasterClinic, fetchMasterClinic];
};

export const useGetAllOpportunityAdmin = () => {
  const [listOpportunityAdmin, setListOpportunityAdmin] = useRecoilState(getMasterOpportunityAdmin)
  const client = useApolloClient()

  const fetchMasterOpportunityAdmin = useCallback(async () => {
    const opportunityAdmin = await getAllOpportunityForAdmin(client)
    setListOpportunityAdmin(opportunityAdmin)
  }, [client, setListOpportunityAdmin])

  useEffect(() => {
    if (!listOpportunityAdmin.length) {
      fetchMasterOpportunityAdmin()
    }
  }, [fetchMasterOpportunityAdmin, listOpportunityAdmin.length])

  return [listOpportunityAdmin, fetchMasterOpportunityAdmin]
}

export const useGetActiveLandingPage = () => {
  const [landingPage, setLandingPage] = useRecoilState(getActiveLandingPage)
  const client = useApolloClient()

  const fetchActiveLandingPage = useCallback(async () => {
    const landingPage = await GetActiveLandingPage(client)
    setLandingPage(landingPage)
  }, [client, setLandingPage])

  useEffect(() => {
    if (!landingPage.length) {
      fetchActiveLandingPage()
    }
  }, [fetchActiveLandingPage, landingPage.length])

  return [landingPage, fetchActiveLandingPage]
}

export const useGetLandingPageAdmin = () => {
  const [landingPageAdmin, setLandingPageAdmin] = useRecoilState(getLandingPageAdmin)
  const client = useApolloClient()

  const fetchLandingPageAdmin = useCallback(async () => {
    const landingPage = await GetLandingPageAdmin(client)
    setLandingPageAdmin(landingPage)
  }, [client, setLandingPageAdmin])

  useEffect(() => {
    if (!landingPageAdmin.length) {
      fetchLandingPageAdmin()
    }
  }, [fetchLandingPageAdmin, landingPageAdmin.length])

  return [landingPageAdmin, fetchLandingPageAdmin]
}

